import { requestService } from './services/requestService';

export const appFetch = (url: string, options?: any) => {
  const baseUrl = `/web-api/consumer-search`;

  // this is temporary since ultimately none of the built apps should have a site unless necessary
  // if (
  //   process.env.NODE_ENV === 'production' &&
  //   window?.location?.hostname !== 'goat-search-one.labs.goateng.com'
  // ) {
  //   // when fetched from remote repositories
  //   baseUrl = '/remote-search-web-api';
  // }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  return requestService({
    url: `${baseUrl}${url}`,
    method: 'GET',
    ...options,
  });
};
